const defaultState = {
  listLoading: false,
  pageCount: 0,
  currentPageNumber: 0,
  entities: null,
  totalResult: 0,
  error: null,
};
export const actionTypes = {
  contactsFetched: 'CONTACTS_ENTITY_FETCHED',
  contactsAppended: 'CONTACTS_ENTITY_APPENDED',
  editContact: 'EDIT_CONTACT',
  addContact: 'ADD_CONTACT',
  deleteContact: 'DELETE_CONTACT',
  restoreContact: 'RESTORE_CONTACT',
  catchError: 'CATCH_ERROR'
};

const getIndex = (array, contactID) => {
  const mappedArray = array.map(item => item.contactID);
  return mappedArray.indexOf(contactID);
};

export const contactsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.contactsFetched: {
      const {totalPageCount, currentPageNumber, contacts, totalResultCount} = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber: currentPageNumber,
        entities: contacts,
        totalResult: totalResultCount,
        error: null
      };
    }
    case actionTypes.contactsAppended: {
      const {totalPageCount, currentPageNumber, contacts, totalResultCount} = action.payload;
      return {
        ...state,
        listLoading: false,
        pageCount: totalPageCount,
        currentPageNumber: currentPageNumber,
        entities: state.entities
          ? [...state.entities, ...contacts]
          : [...contacts],
        totalResult: totalResultCount,
        error: null
      };
    }
    case actionTypes.editContact: {
      const {contactID, ...rest} = action.payload;
      const index = getIndex(state.entities, contactID);
      state.entities[index] = {contactID, ...rest};
      return {
        ...state,
        entities: [...state.entities]
      };
    }
    case actionTypes.addContact: {
      state.entities.unshift({});
      const index = 0;
      state.entities[index] = {...action.payload};
      return {
        ...state,
        entities: [...state.entities]
      };
    }
    case actionTypes.deleteContact: {
      const {contactID} = action.payload;
      const index = getIndex(state.entities, contactID);
      state.entities.splice(index, 1);
      return {
        ...state,
        entities: [...state.entities]
      }
    }
    case actionTypes.restoreContact: {
      const {contactID} = action.payload;
      const index = getIndex(state.entities, contactID);
      state.entities.splice(index, 1);
      return {
        ...state,
        entities: [...state.entities]
      }
    }
    case actionTypes.catchError: {
      const error = `CONTACTS: ${action.payload.error}`;
      return {...state, error};
    }
    default:
      return state;
  }
};

export const actions = {
  contactsFetched: (data) => ({
    type: actionTypes.contactsFetched,
    payload: data
  }),
  contactsAppended: (data) => ({
    type: actionTypes.contactsAppended,
    payload: data
  }),
  editContact: (data) => ({
    type: actionTypes.editContact,
    payload: data
  }),
  addContact: (data) => ({
    type: actionTypes.addContact,
    payload: data
  }),
  deleteContact: (data) => ({
    type: actionTypes.deleteContact,
    payload: data
  }),
  restoreContact: (data) => ({
    type: actionTypes.restoreContact,
    payload: data
  }),
  catchError: (error) => ({type: actionTypes.catchError, payload: {error}}),
};
